import { useRef, useState } from "react";
import api, { API, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";

// Uploads to Emergent object storage and returns an absolute public URL via onChange.
export default function MediaUpload({ value, onChange, label = "Image", testid = "media-upload" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const abs = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(abs(data.url));
      toast.success("Image téléversée");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };

  return (
    <div>
      {label && <div className="text-sm text-stone-600 mb-1">{label}</div>}
      <div className="flex items-center gap-2" data-testid={testid}>
        <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="https://… ou téléversez" className="h-10" data-testid={`${testid}-url`} />
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
        <Button type="button" variant="outline" onClick={() => ref.current?.click()} disabled={busy} className="rounded-full shrink-0" data-testid={`${testid}-btn`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
        </Button>
      </div>
      {value && <img src={abs(value)} alt="Aperçu" className="mt-2 h-20 rounded-lg border object-cover" />}
    </div>
  );
}
